import React from 'react';

function Divider() {
    return(
        <hr />
    );
}

export default Divider;